// 奶水乐园 - 文章模拟数据
export const articles = [
  // ===== 催奶食谱大全 =====
  {
    slug: "cuinai-recipes-tongcao-carp-soup",
    title: "通草鲫鱼汤：最经典的催奶神汤，喝三天奶水涨不停",
    excerpt: "通草搭配鲫鱼，是传统中医催奶配方中的黄金搭档。一碗热腾腾的通草鲫鱼汤，不仅营养丰富，更能显著促进乳汁分泌。",
    category: "cuinai-recipes",
    coverImage: "https://readdy.ai/api/search-image?query=warm%20and%20comforting%20fish%20soup%20in%20elegant%20ceramic%20bowl%20on%20wooden%20table%2C%20soft%20natural%20lighting%2C%20steam%20rising%2C%20homey%20kitchen%20background%2C%20food%20photography%20style%2C%20warm%20cream%20tones&width=800&height=500&seq=article-01&orientation=landscape",
    readTime: 8,
    publishDate: "2025-08-08",
    content: `<p>通草鲫鱼汤是中医经典催奶配方，数百年来被无数妈妈验证有效。这道汤品之所以被誉为"催奶神汤"，是因为它结合了通草的通乳作用和鲫鱼的丰富营养。</p>
<h2>通草鲫鱼汤为什么能催奶？</h2>
<p>通草，别名大通草、白通草，为五加科植物通脱木的茎髓。中医认为通草味甘淡、性微寒，归肺、胃经，具有清热利湿、通气下乳的功效。《本草纲目》中记载通草"通经脉，下乳汁"，是传统中医治疗产后乳汁不通、乳汁不足的常用药材。</p>
<p>鲫鱼含有丰富的优质蛋白、不饱和脂肪酸（尤其是DHA和EPA）、钙、磷、铁等矿物质。鲫鱼肉质细嫩，极易被人体消化吸收，是产后妈妈补充营养的理想食材。鲫鱼中的蛋白质是乳汁合成的重要原料，充足的蛋白质摄入是保证乳汁分泌的基础。</p>
<p><strong>关键营养成分分析：</strong>每100克鲫鱼含蛋白质约17.1克、脂肪约2.7克，热量仅为108千卡，是高蛋白低脂肪的优质食材。通草中的植物甾醇和多糖类物质可以促进乳腺细胞活性，刺激催乳素的分泌。</p>
<h2>通草鲫鱼汤的详细做法</h2>
<h3>所需食材（2人份）</h3>
<ul>
<li>鲜活鲫鱼 1条（约400-500克）</li>
<li>通草 10克</li>
<li>姜片 5片</li>
<li>葱段 适量</li>
<li>料酒 1汤匙</li>
<li>枸杞 15粒（可选）</li>
<li>红枣 5颗（可选）</li>
<li>盐 适量</li>
<li>食用油 少许</li>
</ul>
<h3>制作步骤</h3>
<ol>
<li><strong>鲫鱼处理：</strong>将鲫鱼去鳞、去腮、去内脏，洗净后在鱼身两侧各划3-4刀，用厨房纸吸干表面水分备用。</li>
<li><strong>通草准备：</strong>通草用清水快速冲洗，沥干水分。注意通草质地轻脆，清洗时动作要轻柔。</li>
<li><strong>煎鱼：</strong>锅中放少许油，油热后放入姜片爆香，然后放入鲫鱼，中小火煎至两面微黄。这一步是汤色奶白的关键！</li>
<li><strong>烹料酒：</strong>沿锅边淋入料酒，待酒精挥发后加入足量开水（一定要加开水，汤才会奶白）。</li>
<li><strong>加通草：</strong>放入通草、葱段，大火煮沸后转小火慢炖40-50分钟。</li>
<li><strong>调味：</strong>出锅前5分钟加入枸杞和红枣，最后加入适量盐调味即可。</li>
</ol>
<h2>食用建议与注意事项</h2>
<p><strong>最佳食用时间：</strong>建议在哺乳前1-2小时饮用，每天1-2碗即可。连续食用3-5天通常能明显感受到奶水量的增加。最好趁热饮用，温热状态下的汤品对乳腺的刺激作用最强。</p>
<p><strong>通草用量控制：</strong>通草虽然安全，但也不宜过量使用。每次用量控制在10-15克，每周食用2-3次即可，不建议每天大量使用。过量使用可能引起腹泻等不适。</p>
<p><strong>搭配建议：</strong>可以搭配红豆、花生、木瓜等食材一起炖煮，增强催奶效果。如通草鲫鱼木瓜汤，在汤快炖好时加入切块的青木瓜，不仅能提升风味，还能增强催奶效果。</p>
<p><strong>谁不适合食用：</strong>对鱼类过敏者、严重肾功能不全者应避免食用。正在服用某些药物（如抗凝血药物）的妈妈建议咨询医生后再食用。</p>`,
  },
  {
    slug: "cuinai-recipes-papaya-hoof-soup",
    title: "木瓜猪蹄汤：胶原蛋白满满，奶水质量双重提升",
    excerpt: "青木瓜搭配猪蹄，不仅催奶效果显著，更能让奶水变得更加浓稠有营养。猪蹄中丰富的胶原蛋白通过乳汁传递给宝宝，助力宝宝骨骼发育。",
    category: "cuinai-recipes",
    coverImage: "https://readdy.ai/api/search-image?query=rich%20and%20creamy%20papaya%20and%20pork%20hoof%20soup%20in%20traditional%20clay%20pot%2C%20warm%20kitchen%20setting%2C%20steam%2C%20golden%20broth%2C%20food%20photography%2C%20soft%20natural%20light&width=800&height=500&seq=article-02&orientation=landscape",
    readTime: 7,
    publishDate: "2025-08-06",
    content: `<p>木瓜猪蹄汤是粤港澳地区最受欢迎的催奶汤品之一，因其显著的催奶效果和美味的口感，被称为"妈妈们的美容催奶圣品"。</p>
<h2>青木瓜的催奶奥秘</h2>
<p>青木瓜（未成熟的木瓜）含有丰富的木瓜蛋白酶和木瓜凝乳蛋白酶，这些天然酵素有助于蛋白质的分解和吸收。青木瓜中的植物雌激素样物质可以模仿人体雌激素的部分功能，刺激乳腺发育和乳汁分泌。此外，青木瓜富含维生素A、维生素C和多种矿物质，为哺乳妈妈提供全面的营养支持。</p>
<p>研究显示，青木瓜提取物可以显著提高哺乳期实验动物的乳汁产量，其主要机制是通过调节催乳素受体表达来实现。</p>
<h2>详细做法</h2>
<h3>食材清单</h3>
<ul>
<li>猪蹄 1只（约600-800克，请肉贩帮忙剁成小块）</li>
<li>青木瓜 1个（约500克）</li>
<li>花生仁 50克（提前浸泡2小时）</li>
<li>姜片 6片</li>
<li>红枣 8颗</li>
<li>枸杞 20粒</li>
<li>盐 适量</li>
<li>料酒 2汤匙</li>
</ul>
<h3>步骤</h3>
<ol>
<li>猪蹄冷水下锅，加入2片姜和1汤匙料酒，焯水去血沫，捞出洗净。</li>
<li>青木瓜去皮去籽，切成大块备用。</li>
<li>将焯好的猪蹄、花生仁、姜片、红枣放入砂锅，加足量清水，大火煮沸后转小火炖1.5小时。</li>
<li>加入青木瓜块，继续炖30分钟至木瓜软烂、猪蹄酥软。</li>
<li>最后加入枸杞和适量盐调味，再煮5分钟即可出锅。</li>
</ol>
<h2>营养价值与催奶效果</h2>
<p>猪蹄中丰富的胶原蛋白在炖煮过程中部分转化为明胶，这些明胶和多肽类物质有助于增加乳汁的黏稠度和营养密度。青木瓜酵素可以帮助分解猪蹄中的大分子蛋白，使其更易被吸收利用。花生含有丰富的植物蛋白和不饱和脂肪酸，与动物蛋白互补，营养更全面。</p>`,
  },
  {
    slug: "cuinai-recipes-red-date-longan-tea",
    title: "红枣桂圆枸杞茶：最简单的日常催奶饮品",
    excerpt: "不需要复杂的烹饪，只需保温杯和热水，随时随地补充气血、促进奶水分泌。特别适合职场背奶妈妈和忙碌的新手妈妈。",
    category: "cuinai-recipes",
    coverImage: "https://readdy.ai/api/search-image?query=warm%20red%20date%20and%20longan%20tea%20in%20glass%20cup%2C%20steam%20rising%2C%20soft%20light%2C%20cozy%20atmosphere%2C%20traditional%20Chinese%20herbal%20tea%2C%20gentle%20and%20inviting&width=800&height=500&seq=article-03&orientation=landscape",
    readTime: 5,
    publishDate: "2025-08-04",
    content: `<p>对于忙碌的新手妈妈来说，时间是最宝贵的资源。红枣桂圆枸杞茶操作简单、携带方便，是日常催奶饮品的绝佳选择。</p>
<h2>为什么这三样食材是催奶绝配？</h2>
<p><strong>红枣：</strong>补气养血的佳品，含有丰富的铁元素和维生素C。产后气血亏虚是导致奶水不足的重要原因之一，红枣温补不燥，非常适合产后调理。中医认为"乳汁为气血所化"，气血充足是乳汁分泌旺盛的根本保障。</p>
<p><strong>桂圆（龙眼）：</strong>补心脾、益气血，含有丰富的葡萄糖、蔗糖和蛋白质，能为疲惫的妈妈快速补充能量。桂圆中的烟酸和维生素B族有助于缓解产后疲劳和焦虑情绪。</p>
<p><strong>枸杞：</strong>滋补肝肾、益精明目，含有枸杞多糖和丰富的β-胡萝卜素，能提高机体免疫力，帮助妈妈抵御产后虚弱期的各种感染风险。</p>
<h2>冲泡方法</h2>
<ol>
<li>取红枣5-6颗（去核更佳）、桂圆肉10颗、枸杞15粒放入保温杯中。</li>
<li>用95℃左右的热水冲泡，盖上杯盖焖泡15-20分钟。</li>
<li>可反复冲泡2-3次，直至味道变淡。</li>
<li>建议每天饮用1-2杯，上午和下午各一杯最佳。</li>
</ol>
<h2>升级版配方推荐</h2>
<ul>
<li><strong>加黄芪（5克）：</strong>增强补气效果，适合体质虚弱、气短的妈妈。</li>
<li><strong>加玫瑰花（3朵）：</strong>舒缓情绪、改善产后心情低落，同时增添怡人香气。</li>
<li><strong>加炒米（1小把）：</strong>健脾祛湿，适合食欲不振、消化不良的妈妈。</li>
<li><strong>加麦冬（5克）：</strong>滋阴润燥，适合口干舌燥、阴虚体质的妈妈。</li>
</ul>`,
  },

  // ===== 追奶方法技巧 =====
  {
    slug: "milk-boost-tips-power-pumping",
    title: "强力追奶法（Power Pumping）：7天追奶计划详解",
    excerpt: "Power Pumping是一种模拟宝宝猛长期吸吮模式的科学追奶方法。每天只需1小时，坚持7天，多数妈妈的奶水量能提升30%-50%。",
    category: "milk-boost-tips",
    coverImage: "https://readdy.ai/api/search-image?query=modern%20breast%20pump%20on%20clean%20white%20table%2C%20soft%20morning%20light%2C%20minimalist%20lifestyle%20scene%2C%20warm%20pastel%20tones%2C%20comforting%20and%20peaceful%20atmosphere&width=800&height=500&seq=article-04&orientation=landscape",
    readTime: 10,
    publishDate: "2025-08-08",
    content: `<p>强力追奶法（Power Pumping）是目前国际上公认最有效的非药物追奶方式之一。它通过模拟宝宝猛长期（生长突增期）的高频吸吮模式，向大脑发出"需要更多奶水"的信号，从而促进催乳素分泌，增加乳汁产量。</p>
<h2>Power Pumping 的科学原理</h2>
<p>宝宝的吸吮是刺激乳汁分泌的最强信号。在猛长期（通常发生在出生后2-3周、6周、3个月、6个月左右），宝宝会频繁而集中地吸吮，这种高频刺激会让妈妈的奶水量在1-2天内显著增加，以适应宝宝增长的需求。</p>
<p>Power Pumping正是利用了这一生理机制：通过吸奶器模拟猛长期的高频吸吮模式（密集的短吸-短停循环），人为制造需求信号，从而刺激乳腺增加产奶量。</p>
<h2>标准Power Pumping操作流程</h2>
<p>选择一个你可以放松的1小时（建议在早晨或上午，此时催乳素水平较高）：</p>
<ol>
<li><strong>0-20分钟：</strong>双侧同时吸奶（吸奶器开到舒适的最大档位）</li>
<li><strong>20-30分钟：</strong>休息10分钟（喝水、放松）</li>
<li><strong>30-40分钟：</strong>双侧同时吸奶10分钟</li>
<li><strong>40-50分钟：</strong>休息10分钟</li>
<li><strong>50-60分钟：</strong>双侧同时吸奶10分钟</li>
</ol>
<p><strong>完整模式：</strong>吸20分钟 + 休10分钟 + 吸10分钟 + 休10分钟 + 吸10分钟 = 共1小时</p>
<h2>7天追奶计划</h2>
<p><strong>第1-3天：</strong>每天进行1次Power Pumping（建议在早晨第一次哺乳后进行）</p>
<p><strong>第4-5天：</strong>增加到每天2次（早晨1次、晚上睡前1次）</p>
<p><strong>第6-7天：</strong>保持每天2次，同时确保白天正常哺乳/吸奶不少于8次</p>
<p><strong>效果观察：</strong>大多数妈妈在第3-4天开始看到奶量增加，第7天效果最为明显。</p>
<h2>成功关键与常见误区</h2>
<p><strong>必须配合大量饮水：</strong>每次Power Pumping前后各喝一杯温水（约300ml），整个过程中也可以随时小口喝水。目标是每天总饮水量达到2500-3000ml。</p>
<p><strong>不要过度追求奶量数字：</strong>每个人体质不同，追奶效果也存在个体差异。不要因为单次吸出的奶量不如预期而焦虑，压力本身就是回奶的重要因素。</p>
<p><strong>吸奶器罩杯尺寸正确至关重要：</strong>不合适的罩杯会导致吸奶效率低下甚至乳头损伤。罩杯太大或太小都会影响排空效率。</p>`,
  },
  {
    slug: "milk-boost-tips-latch-position",
    title: "正确的衔乳姿势：90%的追奶问题都从这里开始",
    excerpt: "衔乳姿势不正确是导致奶水不足的隐形杀手。宝宝衔乳不正确会导致排乳不畅，长时间积乳会使乳腺细胞误以为需求减少，从而逐渐降低产奶量。",
    category: "milk-boost-tips",
    coverImage: "https://readdy.ai/api/search-image?query=soft%20close-up%20of%20mother%20gently%20holding%20newborn%20in%20nursing%20position%2C%20warm%20and%20intimate%20scene%2C%20soft%20natural%20light%20through%20curtains%2C%20peaceful%20and%20nurturing&width=800&height=500&seq=article-05&orientation=landscape",
    readTime: 9,
    publishDate: "2025-08-05",
    content: `<p>在哺乳咨询实践中，我们发现超过60%的"奶水不足"案例实际上是由于衔乳姿势不正确导致的排乳效率低下。纠正衔乳姿势后，大多数妈妈的奶水问题迎刃而解。</p>
<h2>正确衔乳的七大要点</h2>
<ol>
<li><strong>宝宝身体呈直线：</strong>耳朵、肩膀、臀部在一条直线上，宝宝不需要转头就能吃到奶。</li>
<li><strong>宝宝腹部紧贴妈妈腹部：</strong>让宝宝尽可能靠近你的身体，不要有间隙。</li>
<li><strong>乳头对准宝宝的鼻子：</strong>这样宝宝需要仰头张大嘴巴来含住乳房。</li>
<li><strong>等待宝宝嘴巴张大到最大：</strong>像打哈欠一样的幅度。</li>
<li><strong>迅速将宝宝拉向乳房：</strong>而不是把乳房塞进宝宝嘴里。</li>
<li><strong>宝宝的下唇外翻：</strong>含住大部分乳晕，下唇覆盖的乳晕多于上唇。</li>
<li><strong>宝宝脸颊饱满鼓起：</strong>吸吮时没有"吧唧吧唧"的声音。</li>
</ol>
<h2>不同哺乳姿势的选择</h2>
<p><strong>摇篮式：</strong>最经典的哺乳姿势，适合足月顺产的宝宝。妈妈坐直，用与哺乳侧同侧的手臂托住宝宝的头颈部。</p>
<p><strong>交叉摇篮式：</strong>用对侧手臂托住宝宝，可以更好地控制宝宝的头部位置，特别适合新生儿和衔乳困难的宝宝。</p>
<p><strong>橄榄球式：</strong>宝宝从妈妈身体侧面"夹"在手臂下，适合剖宫产妈妈（避免压到伤口）、双胞胎妈妈、乳房较大的妈妈。</p>
<p><strong>侧卧式：</strong>妈妈和宝宝面对面侧躺，适合夜间哺乳、剖宫产后恢复期、以及需要休息的妈妈。</p>`,
  },

  // ===== 奶水不足怎么办 =====
  {
    slug: "low-milk-solutions-causes-solutions",
    title: "奶水不足的10大原因及对应解决方案（完整版）",
    excerpt: "从生理因素到生活习惯，全面梳理导致奶水不足的各种原因，并提供针对性的解决方案。很多妈妈发现，解决问题后奶水自然而然地就上来了。",
    category: "low-milk-solutions",
    coverImage: "https://readdy.ai/api/search-image?query=peaceful%20nursing%20mother%20sitting%20by%20window%20in%20soft%20morning%20light%2C%20serene%20and%20tender%20atmosphere%2C%20warm%20cream%20and%20peach%20color%20scheme%2C%20minimalist%20interior&width=800&height=500&seq=article-06&orientation=landscape",
    readTime: 12,
    publishDate: "2025-08-07",
    content: `<p>奶水不足是哺乳期妈妈最焦虑的问题之一。但请先了解一个事实：真正生理性奶水不足的妈妈只占所有哺乳妈妈的约5%。大部分"奶水不足"都是可以纠正的。本文将系统梳理导致奶水不足的十大原因，并提供实用的解决方案。</p>
<h2>原因一：哺乳频率不足</h2>
<p>这是最常见的原因。乳汁分泌遵循"供需平衡"原则：乳房被排空得越频繁，大脑接收到的"需要更多奶水"信号就越强，产奶量就越高。如果两次哺乳间隔时间过长（超过4-5小时），乳腺细胞会减少产奶。</p>
<p><strong>解决方案：</strong>新生儿期每2-3小时哺乳一次（24小时内不少于8-12次），按需喂养，不以时间为唯一标准。夜间催乳素水平最高，不要轻易跳过夜间喂奶。</p>
<h2>原因二：衔乳姿势不正确</h2>
<p>如果宝宝衔乳姿势不正确，无法有效排空乳房，即使每天哺乳次数足够，乳腺得到的需求信号依然不足。</p>
<p><strong>解决方案：</strong>请哺乳顾问或有经验的妈妈帮助检查衔乳姿势，确保宝宝嘴巴张大、含住大部分乳晕、下唇外翻。每侧哺乳时间不少于15-20分钟。</p>
<h2>原因三：水分摄入不足</h2>
<p>乳汁中约87%是水。哺乳期妈妈每天通过乳汁排出约700-900ml水分，需要额外补充。</p>
<p><strong>解决方案：</strong>每天饮水量不少于2500ml（约12杯水）。建议在每次哺乳前喝一杯温水，哺乳时旁边始终放一杯水。</p>
<h2>原因四：营养摄入不足</h2>
<p>哺乳期每天额外需要约500千卡的热量来支持乳汁合成。如果妈妈为了恢复身材而过度节食，将直接影响产奶量和奶水质量。</p>
<h2>原因五：压力和情绪因素</h2>
<p>压力、焦虑、抑郁等负面情绪会抑制催产素的分泌，而催产素是触发"奶阵"（喷乳反射）的关键激素。</p>
<h2>原因六至十及小结</h2>
<p>还包括：睡眠不足、某些药物影响、乳腺组织不足（极少数）、甲状腺功能异常、过早引入奶瓶导致乳头混淆等。每一个原因都有对应的解决方案，建议妈妈们对照检查，找到最适合自己的改善方法。</p>`,
  },
  {
    slug: "low-milk-solutions-mastitis-prevention",
    title: "堵奶和乳腺炎的预防与自救：每位哺乳妈妈都该知道的",
    excerpt: "堵奶和乳腺炎是哺乳期妈妈最怕遇到的问题之一，不仅疼痛难忍，还会严重影响奶水量。学习正确的预防和应急处理方法，让哺乳之路更加顺畅。",
    category: "low-milk-solutions",
    coverImage: "https://readdy.ai/api/search-image?query=soft%20and%20calming%20image%20of%20warm%20compress%20and%20gentle%20self%20care%20scene%2C%20clean%20white%20and%20cream%20tones%2C%20minimal%20lifestyle%20photography%2C%20peaceful%20and%20healing%20atmosphere&width=800&height=500&seq=article-07&orientation=landscape",
    readTime: 9,
    publishDate: "2025-08-03",
    content: `<p>堵奶（乳管堵塞）和乳腺炎是哺乳期妈妈最常见的乳房问题之一。及时正确的处理可以避免问题恶化，保护奶水供应不受影响。</p>
<h2>堵奶的早期识别</h2>
<p>堵奶的典型表现是乳房某一区域出现硬块，触摸时有疼痛感，该区域的皮肤可能发红，但妈妈通常不发热或仅有低热。及时处理堵奶至关重要，因为未解决的堵奶可能在24-48小时内发展为乳腺炎。</p>
<h2>堵奶自救五步法</h2>
<ol>
<li><strong>继续哺乳：</strong>不要因为疼痛而停止哺乳！让宝宝继续吸吮是通乳的最有效方法。让宝宝的下巴对准硬块位置，这有助于该区域排空。</li>
<li><strong>哺乳前热敷：</strong>用温热毛巾敷在硬块处5-10分钟，促进血液循环和奶阵。</li>
<li><strong>哺乳时按摩：</strong>用手指从硬块的外围向乳头方向轻柔按摩，帮助乳管疏通。</li>
<li><strong>哺乳后冷敷：</strong>哺乳结束后用卷心菜叶或冷敷袋敷在硬块处，减轻肿胀和疼痛。</li>
<li><strong>变换哺乳姿势：</strong>尝试不同的姿势让不同区域的乳腺得到充分排空。</li>
</ol>
<h2>乳腺炎的危险信号</h2>
<p>如果出现以下情况，请立即就医：体温超过38.5℃、乳房红肿范围扩大、有脓液从乳头流出、妈妈精神状态明显变差。乳腺炎需要抗生素治疗，但通常不需要停止哺乳。</p>`,
  },

  // ===== 母乳储存方法 =====
  {
    slug: "milk-storage-complete-guide",
    title: "母乳储存完全指南：时间、温度、容器全攻略",
    excerpt: "一图读懂母乳在不同温度下的保存时间，从室温到冷冻，从储存袋选择到解冻方法，手把手教你科学储存母乳，确保宝宝喝的每一口奶都安全营养。",
    category: "milk-storage",
    coverImage: "https://readdy.ai/api/search-image?query=organized%20breast%20milk%20storage%20bags%20in%20clean%20refrigerator%2C%20labeled%20with%20dates%2C%20warm%20and%20neat%20arrangement%2C%20soft%20lighting%2C%20lifestyle%20photography&width=800&height=500&seq=article-08&orientation=landscape",
    readTime: 8,
    publishDate: "2025-08-06",
    content: `<p>正确储存母乳是确保宝宝能持续享受母乳营养的关键技能。无论是产假结束后重返职场的背奶妈妈，还是偶尔需要外出的全职妈妈，科学的母乳储存知识都是必备的。</p>
<h2>不同温度下的母乳保存时间表</h2>
<p><strong>室温（25℃以下）：</strong>新鲜母乳可保存4小时。如果室温超过25℃，建议控制在2小时内使用。挤出的母乳应尽快冷藏。</p>
<p><strong>冷藏室（0-4℃）：</strong>新鲜母乳可保存3-5天。但建议放在冷藏室靠后、温度最稳定的位置，而不是门架上。如果无法保证温度恒定在4℃以下，建议72小时内使用。</p>
<p><strong>冷冻室（-18℃以下）：</strong>可保存3-6个月。如果使用-20℃以下的深冻冰箱，最长可保存12个月。但为了保留最佳营养和口感，建议在6个月内使用。</p>
<h2>母乳储存容器的选择</h2>
<ul>
<li><strong>专用母乳储存袋：</strong>最推荐！无菌、密封性好、占用空间小、方便标注日期。选择不含BPA的食品级材质。</li>
<li><strong>玻璃储存瓶：</strong>适合冷藏短期储存。玻璃不吸附奶水中的免疫成分，但占用空间较大且易碎。</li>
<li><strong>食品级塑料瓶：</strong>轻便不易碎，适合冷藏使用。但长期储存可能吸附部分脂肪和免疫因子。</li>
</ul>
<h2>母乳解冻的正确方法</h2>
<p><strong>最佳方法——冷藏室自然解冻：</strong>提前一晚将冷冻的母乳放入冷藏室自然解冻。解冻后的母乳在冷藏室可保存24小时。</p>
<p><strong>快速方法——流水解冻：</strong>将储存袋放入流动的冷水中，逐渐调高水温至温热（不超过40℃），直至完全解冻。解冻后应在2小时内使用。</p>
<p><strong>严禁使用微波炉解冻！</strong>微波炉加热会破坏母乳中的免疫球蛋白和溶菌酶等活性成分，且加热不均匀会产生热点，可能烫伤宝宝的口腔。</p>`,
  },

  // ===== 新生儿喂养指南 =====
  {
    slug: "feeding-guide-newborn-first-week",
    title: "新生儿出生第一周喂养全攻略：从初乳到成熟乳",
    excerpt: "宝宝出生后的第一周是母乳喂养的关键期。从珍贵的初乳到过渡乳再到成熟乳，了解每个阶段的特点和喂养要点，为宝宝打下坚实的营养基础。",
    category: "feeding-guide",
    coverImage: "https://readdy.ai/api/search-image?query=tender%20close-up%20of%20newborn%20baby%20hand%20holding%20mothers%20finger%2C%20soft%20cream%20blanket%2C%20gentle%20natural%20light%2C%20warm%20and%20intimate%20newborn%20photography&width=800&height=500&seq=article-09&orientation=landscape",
    readTime: 10,
    publishDate: "2025-08-07",
    content: `<p>宝宝出生后的第一周，是母乳喂养的黄金窗口期。这一周内，妈妈的乳汁会经历从初乳到过渡乳再到成熟乳的奇妙变化，每个阶段都有不同的喂养重点和注意事项。</p>
<h2>第一阶段：初乳期（产后1-3天）</h2>
<p>初乳是妈妈送给宝宝的第一份珍贵礼物，被称为"液体黄金"。初乳呈浓稠的黄色或橙色，含有极高浓度的免疫球蛋白（尤其是IgA）、乳铁蛋白和白细胞，帮助宝宝建立最初的免疫防线。</p>
<p><strong>初乳的量：</strong>每次约5-15ml，看起来很少，但恰好满足新生儿只有弹珠大小的胃容量。请不要因为量少而焦虑，频繁哺乳（每1.5-2小时一次）就是最好的下奶方法。</p>
<h2>第二阶段：过渡乳期（产后3-5天）</h2>
<p>这是妈妈们常说的"下奶期"或"涨奶期"。乳汁量开始显著增加，颜色由黄色逐渐变为白色，成分也开始变化以适应宝宝的成长需求。</p>
<h2>第三阶段：成熟乳期（产后5天以后）</h2>
<p>乳汁成分趋于稳定，每次哺乳的前乳含水量较高（解渴），后乳脂肪含量较高（饱腹）。确保宝宝每次哺乳吃到后乳非常重要。</p>`,
  },
  {
    slug: "feeding-guide-monthly-milestones",
    title: "0-12个月宝宝喂养里程碑：每月喂养量和频率指南",
    excerpt: "从新生儿到1岁，每个月宝宝的喂养需求都在变化。本指南详细列出各月龄的参考喂养量、频率和发育里程碑，让新手妈妈心中有数，喂养不焦虑。",
    category: "feeding-guide",
    coverImage: "https://readdy.ai/api/search-image?query=adorable%20baby%20growth%20milestone%20series%20in%20soft%20pastel%20setting%2C%20warm%20cream%20background%2C%20gentle%20developmental%20photography%2C%20baby%20milestones%20concept&width=800&height=500&seq=article-10&orientation=landscape",
    readTime: 11,
    publishDate: "2025-08-05",
    content: `<p>了解宝宝在各个月龄的喂养需求和发育里程碑，可以帮助妈妈更好地规划喂养节奏，减少不必要的焦虑。本指南基于世界卫生组织和中国营养学会的最新建议整理。</p>
<h2>0-1个月：按需喂养期</h2>
<p>每天喂养8-12次，每次15-20分钟单侧或30-40分钟双侧。胃容量约30-90ml。这个阶段完全按需喂养，不要看时间。</p>
<h2>1-3个月：建立规律期</h2>
<p>每天喂养7-9次，逐渐形成约3小时的喂养间隔。胃容量约90-150ml。开始出现昼夜节律，夜间可能睡4-5小时长觉。</p>
<h2>3-6个月：稳定喂养期</h2>
<p>每天喂养6-8次，胃容量约150-210ml。纯母乳喂养的宝宝在6个月前不需要额外喝水。</p>
<h2>6-12个月：辅食添加期</h2>
<p>继续保持母乳喂养，同时开始添加辅食。母乳仍然是主要的营养来源（提供约50%以上的能量需求），辅食是补充和过渡。</p>`,
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug) || null;
};

export const getRelatedArticles = (currentSlug: string, categorySlug: string, count: number = 3) => {
  return articles
    .filter((a) => a.category === categorySlug && a.slug !== currentSlug)
    .slice(0, count);
};

export const getFeaturedArticles = (count: number = 6) => {
  return articles.slice(0, count);
};